import { render, staticRenderFns } from "./divarAdvertise.vue?vue&type=template&id=1e1dc7d0&scoped=true"
import script from "./divarAdvertise.vue?vue&type=script&lang=js"
export * from "./divarAdvertise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1dc7d0",
  null
  
)

export default component.exports